import { setupResourceStore } from '@/utils'
import Merchant from '@/resources/Merchant';

const resource = setupResourceStore(Merchant)


const state = {
  ...resource.state
};

const getters = {
  ...resource.getters
};

const actions = {
  ...resource.actions
};

const mutations = {
  ...resource.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};